export const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';
export default function clearAllErrors() {
  return { type: CLEAR_ALL_ERRORS };
}
